import { createContext, useContext } from 'react';

/**
 * NavDotContext — lets any screen ask the nav to re-check its unread dots
 * (unprayed today, unseen Discover items) immediately, rather than waiting for
 * Layout's five-minute poll.
 *
 * This lives in its own module rather than in Layout.js because of an import
 * cycle. Layout mounts RecipientsProvider, which imports the recipient modals
 * from screens/PrayerScreen, which imports useNavDots — previously from
 * Layout, closing the loop:
 *
 *     Layout -> RecipientsContext -> PrayerScreen -> Layout
 *
 * Webpack tolerated it, because the binding is only read at render time by
 * which point both modules have finished evaluating. But a cycle through the
 * app's two largest modules is a latent trap: any future module-scope use of
 * useNavDots would read `undefined` with no obvious cause. A leaf module with
 * no imports of its own cannot participate in a cycle at all.
 */
export const NavDotContext = createContext({ refreshDots: () => {} });

export function useNavDots() {
  return useContext(NavDotContext);
}
